import React, { useState } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";

const DropDown = (props) => {
  const [error, setError] = useState("");

  const handleBlur = (e) => {
    const { value } = e.target;
    let errorMessage = "";

    if (props.isRequired && !value) {
      errorMessage = `${props.title} is required.`;
    } else if (props.controlFuncBlur) {
      errorMessage = props.controlFuncBlur(e) || "";
    }

    setError(errorMessage);
  };

  return (
    <div className={props.classDiv ? props.classDiv : "form-group"}>
      <label className={props.ClassLabel ? props.ClassLabel : mainTable.label}>
        {props.title}
        {props.classStar && (
          <span className={props.classStar ? props.classStar : "hidden"}>
            *
          </span>
        )}
      </label>
      <div className="relative">
        <select
          name={props.name}
          value={props.selectedOption}
          onChange={props.controlFunc}
          onBlur={handleBlur}
          className={`${props.Class ? props.Class : mainTable.inputSelect} ${
            props.disabled ? "bg-gray-50 cursor-not-allowed" : ""
          }`}
          disabled={props.disabled}
          tabIndex={props.tabIndex}
          title={
            props.selectedOption
              ? props.options.find((opt) => opt.value === props.selectedOption)
                  ?.label
              : props.placeholder
          }
        >
          <option value="">{props.placeholder}</option>
          {props.options.map((opt) => {
            return (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            );
          })}
        </select>
        {/* custom arrow */}
        <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
          <svg
            className="w-4 h-4" // smaller size
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </div>
      {error && <span className="text-red-500">{error}</span>}
    </div>
  );
};

DropDown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  controlFunc: PropTypes.func,
  controlFuncBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  isRequired: PropTypes.bool,
  classDiv: PropTypes.string,
  ClassLabel: PropTypes.string,
  classStar: PropTypes.string,
  Class: PropTypes.string,
};

DropDown.defaultProps = {
  disabled: false,
  isRequired: false,
};

export default DropDown;
